import { extendObservable, action } from 'mobx'

class SidebarStore {
  constructor () {
    extendObservable(this, {
      active: false,
      template: null,
      closing: false,
      animationDuration: 300,
      props: null
    })
  }

  openSidebar = action(({ template, ...props }) => {
    this.active = true
    this.template = template
    this.props = props
  })

  closeSidebar = action(() => {
    this.closing = true
    this.template = null
    this.props = null

    setTimeout(() => {
      this.closing = false
      this.active = false
    }, this.animationDuration)
  })
}

export default SidebarStore
